import styled from "styled-components";
import { useLayoutEffect, useRef } from "react";
import { useReferral } from "../referral";
import { useTranslation } from "react-i18next";

const Banner = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 12px 20px;
  background: #e7f0ff;
  color: #074199;
  border-bottom: 1px solid #81aaee;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  overflow-wrap: anywhere;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1001;
`;

export const ReferralPlanBand = styled.div.attrs({ "data-testid": "referral-plan-band" })`
  margin: 14px -16px 0;
  padding: 10px 16px;
  background: #e7f0ff;
  border-top: 1px solid #81aaee;
  color: #074199;
  font: 700 14px/1.4 'Lato', sans-serif;
  text-align: center;
  flex-shrink: 0;
`;

export const ReferralPlanNote = styled.p`
  margin: 12px 0;
  color: #1e1e1e;
  font: 400 14px/1.4 'Lato', sans-serif;
`;

export function ReferralBanner() {
  const { referral } = useReferral();
  const { t } = useTranslation();
  const banner = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const element = banner.current;
    if (!element) return;
    const updateHeight = () => document.documentElement.style.setProperty(
      "--referral-banner-height", `${element.getBoundingClientRect().height}px`
    );
    updateHeight();
    const observer = new ResizeObserver(updateHeight);
    observer.observe(element);
    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty("--referral-banner-height");
    };
  }, [referral]);
  return referral ? (
    <Banner ref={banner} role="status" data-testid="referral-banner">
      {t("account.referralBanner.unlocked", { name: referral.referrerFirstName })}
    </Banner>
  ) : null;
}
